import { bulkAdd, translate as t, exist } from './translations';
import locale from './locale';

require('./adapters/$.t');
require('./adapters/BvApi.t');

export {
  bulkAdd,
  t,
  exist,
  locale,
};
